import styles from "./RegisterLoginPage.module.css";
import Register from "../../components/register/Register";
import Login from "../../components/login/Login";
import { useState } from "react";

export default function RegisterLoginPage({ setIsLoggedIn }) {
  const [showRegisterForm, setShowRegisterForm] = useState(true);
  const [showLoginForm, setShowLoginForm] = useState(false);

  function registerForm() {
    setShowRegisterForm(true);
    setShowLoginForm(false);
  }
  function loginForm() {
    setShowLoginForm(true);
    setShowRegisterForm(false);
  }
  return (
    <>
      <div className={styles.registerLogin_container}>
        <div className={styles.registerLogin_subcontainer}>
          <div className={styles.brandMark} aria-hidden="true">Q</div>
          <h1 className={styles.quiz_title}>Quizzie</h1>
          <p className={styles.subtitle}>Create engaging quizzes, share them in seconds, and understand every response.</p>
          <div className={styles.loginRegister_btns_wrapper}>
            <button type="button"
              className={`${styles.signup_btn} ${
                showRegisterForm && styles.activeBtn
              }`}
              onClick={registerForm}
            >
              Sign Up
            </button>
            <button type="button"
              className={`${styles.login_btn} ${
                showLoginForm && styles.activeBtn
              }`}
              onClick={loginForm}
            >
              Log In
            </button>
          </div>
          <div className={styles.form_container}>
            {showRegisterForm && <Register setIsLoggedIn={setIsLoggedIn} />}
            {showLoginForm && <Login setIsLoggedIn={setIsLoggedIn} />}
          </div>
        </div>
      </div>
    </>
  );
}
